import {inject, injectable} from 'inversify'
import HttpHandler from '@/common/services/connect/HttpHandler'
import {SingletonService} from '@/common/dependency.configs'
import type RestResponse from '@/common/data/RestResponse'

@SingletonService
@injectable()
export class CoreAccountTaxPlanService {
  constructor(@inject(HttpHandler) private httpHandler: HttpHandler) {}

  get(
    workspaceUUID: string,
    enrollmentId: number,
    accountId: number
  ): Promise<RestResponse<CoreAccountTaxPlan | undefined>> {
    return this.httpHandler.get(
      `{{boltsbranch}}/workspace/${workspaceUUID}/enrollment/${enrollmentId}/account/${accountId}/core-tax-plan`
    )
  }

  post(workspaceUUID: string, enrollmentId: number, accountId: number): Promise<RestResponse<CoreAccountTaxPlan>> {
    return this.httpHandler.post(
      `{{boltsbranch}}/workspace/${workspaceUUID}/enrollment/${enrollmentId}/account/${accountId}/core-tax-plan`
    )
  }

  getAndSave(
    workspaceUUID: string,
    enrollmentId: number,
    accountId: number
  ): Promise<RestResponse<CoreAccountTaxPlan | undefined>> {
    return this.get(workspaceUUID, enrollmentId, accountId).then((response) => {
      return response.data.payload?.savedToCoreTimestamp
        ? Promise.resolve(response)
        : this.post(workspaceUUID, enrollmentId, accountId)
    })
  }
}

export interface CoreAccountTaxPlan {
  accountId: number
  savedToCoreTimestamp: string
}
